export default "__VITE_ASSET__8fd497b4__"